export class Captcha {

    constructor({isVisible = tooManyLoginFailures} = {}) {
        this.response = undefined;
        this.widget = undefined;
        this.isVisible = isVisible;
    }

    reset() {
        this.widget && this.widget.reset();
        this.response = undefined;
    }

    isValid() {
        return !this.isVisible() || !!this.response;
    }
}

function tooManyLoginFailures() {
    return localStorage.getItem('loginAttempts') >= window.env.captcha.maxFailedAttempts;
}



// WEBPACK FOOTER //
// ./src/portal/components/captcha/captcha.model.js